import React from "react";
import { ModeRendererProps } from "./types";

export function VasarelyFosterMode({ brand }: ModeRendererProps) {
  // Futurist engineering meets parametric op-art
  // Diagrid patterns, curved lattices, light skins
  
  return (
    <g>
      <rect x="0" y="0" width="794" height="1123" fill={brand.paper} />
      
      {/* Diagrid pattern - Foster's signature structural system */}
      {Array.from({ length: 20 }).map((_, i) => {
        const y = 80 + i * 50;
        return (
          <g key={`diagrid-row-${i}`}>
            {Array.from({ length: 10 }).map((_, j) => {
              const x = 60 + j * 70;
              return (
                <g key={`diagrid-${i}-${j}`}>
                  <line
                    x1={x}
                    y1={y}
                    x2={x + 70}
                    y2={y + 50}
                    stroke={brand.aqua}
                    strokeWidth="1.5"
                    opacity={0.4}
                  />
                  <line
                    x1={x + 70}
                    y1={y}
                    x2={x}
                    y2={y + 50}
                    stroke={brand.violet}
                    strokeWidth="1.5"
                    opacity={0.4}
                  />
                </g>
              );
            })}
          </g>
        );
      })}
      
      {/* Curved lattice - parametric curve */}
      {Array.from({ length: 30 }).map((_, i) => {
        const t = i / 29;
        const x1 = 100 + t * 600;
        const y1 = 300 + Math.sin(t * Math.PI * 2) * 80;
        const x2 = 100 + (i + 1) / 29 * 600;
        const y2 = 300 + Math.sin(((i + 1) / 29) * Math.PI * 2) * 80;
        
        return (
          <line
            key={`curve-${i}`}
            x1={x1}
            y1={y1}
            x2={x2}
            y2={y2}
            stroke={brand.amber}
            strokeWidth="2"
            opacity={0.6}
          />
        );
      })}
      
      {/* Supporting radial lines from curve */}
      {Array.from({ length: 15 }).map((_, i) => {
        const t = i / 14;
        const x = 100 + t * 600;
        const y = 300 + Math.sin(t * Math.PI * 2) * 80;
        return (
          <line
            key={`radial-${i}`}
            x1={x}
            y1={y}
            x2={x}
            y2={y + 120}
            stroke={brand.violet}
            strokeWidth="0.8"
            opacity={0.3}
          />
        );
      })}
      
      {/* Light skin effect - overlapping transparent layers */}
      {Array.from({ length: 5 }).map((_, i) => {
        const offset = i * 15;
        return (
          <ellipse
            key={`skin-${i}`}
            cx={397}
            cy={650}
            rx={200 + offset}
            ry={140 + offset * 0.7}
            fill="none"
            stroke={brand.aqua}
            strokeWidth="2"
            opacity={0.15 - i * 0.02}
          />
        );
      })}
      
      {/* Vasarely optical interference pattern */}
      {Array.from({ length: 12 }).map((_, i) =>
        Array.from({ length: 8 }).map((_, j) => {
          const x = 180 + j * 60;
          const y = 800 + i * 26;
          const phase = (i + j) * 0.3;
          return (
            <circle
              key={`optical-${i}-${j}`}
              cx={x + Math.sin(phase) * 10}
              cy={y}
              r={6 + Math.cos(phase) * 3}
              fill={brand.violet}
              opacity={0.3}
            />
          );
        })
      )}
      
      {/* Parametric mesh overlay */}
      {Array.from({ length: 8 }).map((_, row) =>
        Array.from({ length: 12 }).map((_, col) => {
          const x = 80 + col * 53;
          const y = 460 + row * 30;
          const distort = Math.sin(col * 0.5) * 5 + Math.cos(row * 0.5) * 5;
          
          return (
            <rect
              key={`mesh-${row}-${col}`}
              x={x + distort}
              y={y}
              width="48"
              height="26"
              fill="none"
              stroke={brand.deep}
              strokeWidth="0.5"
              opacity={0.2}
            />
          );
        })
      )}
      
      {/* Structural nodes at intersections */}
      {Array.from({ length: 10 }).map((_, i) => {
        const x = 100 + i * 60;
        const y = 300 + Math.sin((i / 9) * Math.PI * 2) * 80;
        return (
          <circle
            key={`node-${i}`}
            cx={x}
            cy={y}
            r="4"
            fill={brand.amber}
            opacity={0.8}
          />
        );
      })}
    </g>
  );
}
